import { ReduxRawState } from 'src/AppState/Redux/utils/ReduxRawState';
import { computed } from 'mobx';
import {
    ConstraintType,
    GrantType,
    Permission,
    permissionGrantsSchema,
    PermissionGrantsType,
} from './PermissionGrants.types';
import { groupAndMergePermissionConstraints } from './PermissionGrants.helpers';
export class PermissionGrantsState {
    public constructor(private readonly reduxStore: ReduxRawState) {}

    @computed.struct private get grantsFromRedux(): PermissionGrantsType {
        const userData = this.reduxStore.getStateReactive().user;

        if (userData === undefined) {
            return [];
        }

        try {
            //@ts-expect-error - This is where the data is collected from redux
            const resultIm = userData.getIn(['data', 'permissionGrants']);

            if (resultIm === undefined) {
                return [];
            }

            const result = resultIm.toJS();

            if (result === undefined) {
                return [];
            }

            const data = permissionGrantsSchema.safeParse(result);

            if (data.success) {
                return data.data;
            }

            console.error('permissionGrants - incorrect data', result);
        } catch (error) {
            console.error('permissionGrants - js runtime', error);
        }

        return [];
    }

    private get staffPermissions(): Map<string, Array<ConstraintType>> {
        return groupAndMergePermissionConstraints(this.grantsFromRedux);
    }

    public get = (permissionId: Permission): GrantType | null => {
        const permissionConstraints = this.staffPermissions.get(permissionId);
        if (permissionConstraints === undefined) {
            return null;
        }

        return {
            permission: permissionId,
            constraints: permissionConstraints,
        };
    };

    /**
     * @description Verifies whether the currently logged-in staff member has the assigned permission.
     * Important: Each permission can have constraints. If you wish to account for these, use the get() method,
     * which will also return the constraints that you can then check.
     */
    public has = (permissionId: Permission): boolean => {
        const permissionConstraints = this.get(permissionId);

        if (permissionConstraints === null) {
            return false;
        }

        return true;
    };
}
